import { render, staticRenderFns } from "./BaseSaving.vue?vue&type=template&id=4c179517&scoped=true&"
import script from "./BaseSaving.vue?vue&type=script&lang=js&"
export * from "./BaseSaving.vue?vue&type=script&lang=js&"
import style0 from "./BaseSaving.vue?vue&type=style&index=0&id=4c179517&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c179517",
  null
  
)

export default component.exports